// 환경별 설정 중앙 관리 (AGENTS.md 가이드라인 기반)

interface EnvironmentConfig {
  apiBaseUrl: string;
  environment: 'development' | 'production';
  enableStubServices: boolean;
}

const getEnvironmentConfig = (): EnvironmentConfig => {
  const isDevelopment = process.env.NODE_ENV === 'development';

  if (isDevelopment) {
    return {
      apiBaseUrl: 'http://localhost:3300',
      environment: 'development',
      enableStubServices: true
    };
  }

  // 프로덕션 환경 - 같은 도메인 사용
  return {
    apiBaseUrl: '', // 상대 경로로 같은 도메인의 API 사용
    environment: 'production',
    enableStubServices: false
  };
};

export const ENV_CONFIG = getEnvironmentConfig();

// API URL 구성 헬퍼 함수
export const getApiUrl = (endpoint: string): string => {
  return `${ENV_CONFIG.apiBaseUrl}${endpoint}`;
};

export default ENV_CONFIG;